
































import {Component, Vue} from 'vue-property-decorator';

@Component({
  data: () => ({}),
})
export default class SkeletonLoader extends Vue {}
